module.exports = __webpack_public_path__ + "img/Frame 796three.f8c1da2c.png";